import { DipType } from "interfaces";
import { isVideoFile } from "utils/fileType";
import React, { useMemo } from "react";
import { Image, Video } from "./styles";

interface AssetsProps {
	dipType: DipType | undefined;
	variantUrl: string;
}

const AssetsComponent: React.FC<AssetsProps> = ({ dipType, variantUrl }) => {
	const isVideo = useMemo(() => isVideoFile(variantUrl), [variantUrl]);

	return isVideo ? (
		<Video
			dipType={dipType}
			autoPlay
			loop
			muted
			playsInline
			src={variantUrl}
		></Video>
	) : (
		<Image dipType={dipType} src={variantUrl} />
	);
};

export const Assets = React.memo(AssetsComponent);
